import {
    Autocomplete,
    Button, Card, CardContent,
    Checkbox,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Stack,
    TextField,
    Tooltip
} from '@mui/material';
import { useStoreState } from 'pullstate';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BackdropLoader from '../../components/BackdropLoader.jsx';
import { AppStore } from '../../stores/AppStore.js';
import { api } from '../../utils/apiFunctions';
import { updateLocalArrayObjects } from '../../utils/localStorageFunctions.js';
import NewDepartmentDialog from '../department/NewDepartmentDialog.jsx';
import NewTitleDialog from '../title/NewTitleDialog.jsx';
import EmployeeDialogSuspend from './EmployeeDialogSuspend.jsx';
import EmployeeInfo from './EmployeeInfo.jsx';
import { getDepartments, getEmployees, getPeopleBuilders, getTitles, getWorkLocations } from '../../utils/getData.js';

const Profile = () => {
    const { userId } = useParams()
    const employeeId = userId;
    const m = { 'work': 'ETRO Phone', 'ETRO Phone': 'work', 'personal': 'Personal Phone', 'Personal Phone': 'personal', '': '' }

    
    const { employees, loading, titles, workLocations } = useStoreState(AppStore);
    const departments = useStoreState(AppStore, s => s.departments);
    const openAlert = useStoreState(AppStore, s => s.snackbar.openAlert);
    const [userEmployee, setUserEmployee] = useState(useStoreState(AppStore, s => s.user));
    const [disabled, setDisabled] = useState(true);
    const [disabledCoach, setDisabledCoach] = useState(false);
    const [coachChecked, setCoachChecked] = useState(false)
    const [open, setOpen] = useState(false);
    const [openChangePhoto, setOpenChangePhoto] = useState(false);
    const [openDialogNewDepartment, setOpenDialogNewDepartment] = useState(false);
    const [openDialogNewTitle, setOpenDialogNewTitle] = useState(false);
    const [employee, setEmployee] = useState(null);
    const [employeeFields, setEmployeeFields] = useState({
        department: null,
        departmentId: null,
        title: null,
        titleId: null,
        coach: null,
        manager: null,
        workLocation: null,
        workLocationId: null,
        phoneType: null,
        phone: null
    });
    /*
    employeeFieldsToUpdate has to match Sequelize model: {
        department: { department: "name of department" },
        department_id: ID of dept,
        title: { title: "name of Title" }, 
        title_id: ID of title,
        work_location: { building_name:  },
        work_location_id: 
        etro_type_phone: 'work' : 'personal'
        direct_manager: "name of direct manager",
        coach: "email of coach"
    }
    */
    const [employeeFieldsToUpdate, setEmployeeFieldsToUpdate] = useState({ userId: userId });
    const [fileName, setFileName] = useState('')
    const [image, setImage] = useState('')

    const initRef = useRef(false);
    
    useEffect(() => {
        if (!departments) getDepartments();
        if (!employees) getEmployees();
        if (!titles) getTitles();
        if (!workLocations) getWorkLocations();
        
        const found = employees?.find(e => e.id === employeeId);

        if (initRef.current) return;
        if (!found) return;

        setEmployee(found)
        // console.log(found)
        const bruh = {
            department: found?.department?.department,
            title: found?.title?.title,
            coach: found?.coach,
            manager: found?.direct_manager,
            workLocation: found?.work_location?.building_name,
            phoneType: found?.etro_type_phone,
            phone: found?.phone
        };
        setEmployeeFields(bruh)
        initRef.current = true;
    }, [departments, employees, titles, workLocations]);
    
    const navigate = useNavigate()
    const fileInputRef = useRef(null)

    useEffect(() => {
        setDisabled(!(userEmployee.is_lifecycle_admin || userEmployee.is_hr_admin));
    }, [userEmployee, employees]);
    
    const findManagerEmail = (directManagerEmail) => {
        const managerEmail = employees.find(employee => employee.email === directManagerEmail)
        return managerEmail?.full_name
    }

    const suspendUser = useCallback(async () => {
        setOpen(false)
        AppStore.update((s) => { s.loading = true })

        try {
            const response = await api.put(`/user/suspend/${employee.id}`, { suspended: !employee.suspended })

            if (response.status === 200) {
                setEmployee(response.data)
                updateLocalArrayObjects('employees', employee.id, { suspended: !employee.suspended })
                const employeesWithThisCoach = employees.filter(emp => emp.coach === employee.full_name)
                employeesWithThisCoach.forEach(emp => {
                    updateLocalArrayObjects('employees', emp.id, { coach: '' })
                })

                openAlert(`User ${employee.suspended ? 'Activated' : 'Suspended'} successfully`, 'success')
            } else {
                openAlert('Oops! Something went wrong', 'error')
            }
            AppStore.update((s) => { s.loading = false })

        } catch (error) {
            openAlert('Oops! Something went wrong', 'error')
            console.error('Something was wrong:', error);
            AppStore.update((s) => { s.loading = false })
        }

    }, [employee])

    async function updateVcardPhoto() {
        const formData = new FormData()
        formData.append('image', image)
        formData.append('user', JSON.stringify({full_name: employee.full_name, email: employee.email}));

        try {
            const response = await api.post('/vcard/updatePhoto', formData);
            return { success: true, status: response.status }
        } catch (error) {
            return { success: false, status: error.response.status }
        }
    }

    const changeSlackPhoto = async (e) => {

        const formData = new FormData()
        formData.append('image', image)
        formData.append('email', employee.email)

        try {
            const response = await api.post(`/user/update-slack-photo/${employee.id}`, formData)
            return { success: true, status: response.status }
        } catch (error) {
            return { success: false, status: error.response.status }
        }
    }

    const changeGooglePhoto = async (e) => {
        const formData = new FormData()
        formData.append('image', image)
        formData.append('email', employee.email)

        try {
            const response = await api.post('/change-google-photo', formData)
            return { success: true, status: response.status }
        } catch (error) {
            return { success: false, status: error.response.status }
        }
    }

    const updateProfilePhoto = async () => {
        if ( image === '' ) {
            openAlert('No image selected. Please try again.', 'error')    ;
            return;
        }
        AppStore.update((s) => { s.loading = true })

        const slackSuccess = await changeSlackPhoto();
        const googleSuccess = await changeGooglePhoto();
        const vcardSuccess = await updateVcardPhoto();

        if ( !slackSuccess.success || !vcardSuccess.success || !googleSuccess.success ){
            openAlert(
                `
                Slack success:  ${slackSuccess.success}\t|\tstatus: ${slackSuccess.status}\n
                Google success: ${googleSuccess.success}\t|\tstatus: ${googleSuccess.status}\n
                Vcard success:  ${vcardSuccess.success}\t|\tstatus: ${vcardSuccess.status}\n
                `,
                'error'
            );
        }
        else {
            // Convert image to base64 and update AppStore
            const reader = new FileReader();
            reader.onload = (e) => {
                const photoData = e.target.result;
                
                // Update the employee in AppStore
                AppStore.update((s) => {
                    const employeeIndex = s.employees.findIndex(emp => emp.id === employee.id);
                    if (employeeIndex !== -1) {
                        s.employees[employeeIndex].photo_url = photoData;
                    }
                });
            };
            reader.readAsDataURL(image);
            
            openAlert('Photo updated successfully.', 'success');
        }


        AppStore.update((s) => { s.loading = false })
        setOpenChangePhoto(false)
    }

    const handleUpdateEmployee = useCallback(async () => {
        if (Object.keys(employeeFieldsToUpdate).length < 2) {
            openAlert('No changes were made', 'warning')
            return
        }
        AppStore.update((s) => { s.loading = true })
        
        const coachSelected = employees.find(e => e.full_name === employeeFields?.coach)

        let res;
        let errorTripped = false;

        // UPDATE GOOGLE INFO
        try {
            res = await api.put(`/user/update/google/${employeeId}`, employeeFieldsToUpdate, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        } catch (error) {
            errorTripped = true;
            openAlert(`Error updating Google Admin: ${error.status} | ${error.response?.data?.message}`, 'error')
            res = error;
        }
        
        if (res?.status === 200 || res?.status === 403 ) {
            // UPDATE EMPLOYEE INFO
            try {
                await api.put(`/user/update/${employeeId}`, employeeFieldsToUpdate, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
            } catch (error) {
                errorTripped = true;
                console.log(error)
                console.log(error.response)
                openAlert(`Error updating Employee: ${error.status} | ${error.response.data.message}`, 'error')
                AppStore.update((s) => { s.loading = false })
            }
            // UPDATE PEOPLE BUILDER INFO
            if ( employeeFieldsToUpdate?.coach ) {
                try {
                    await api.patch(`/people-builders/${employeeId}`, {
                        coach_id: coachSelected?.id
                    })
                } catch (error) {
                    errorTripped = true;
                    openAlert(`Error updating People Builder: ${error.status}`, 'error')
                }
            }
            // UPDATE VCARD TITLE
            if (employeeFieldsToUpdate?.title_id) {
                const data = { title: employeeFieldsToUpdate.title, user: employee.full_name }
                try {
                    await api.post('/vcard/updateTitle', data)
                } catch (error) {
                    errorTripped = true;
                    openAlert(`Error updating Vcard: ${error.status} | ${error.response.data.message}`, 'error')
                }
            }
            
            if (!errorTripped) 
                openAlert(`${employee.full_name} updated successfully`, 'success')
            updateLocalArrayObjects('employees', employeeId, employeeFieldsToUpdate)
            getPeopleBuilders()
            navigate('/employee')
        }

        AppStore.update((s) => { s.loading = false })
    }, [employees, employeeFields, employeeFieldsToUpdate])

    const handleClickOpen = () => {
        setOpen(true);
    }

    const handleClickOpenDialogNewDepartment = () => {
        setOpenDialogNewDepartment(true)
    }

    const handleCloseDialog = () => {
        setOpen(false);
        setOpenChangePhoto(false);
        setOpenDialogNewDepartment(false);
        setOpenDialogNewTitle(false);
        setFileName('')
    }

    const handleReturnToListUser = useCallback(() => {
        navigate('/employee')
    })

    const handleClick = () => {
        fileInputRef.current.click();
    }

    return (
        <Container sx={{ mt: 10 }} maxWidth="xl" >
            <>
                <BackdropLoader openBackdrop={loading} />
                <Card sx={{ mt: 4 }}>
                    <CardContent>
                        <Stack spacing={2}>
                            <EmployeeInfo setOpenChangePhoto={setOpenChangePhoto} employee={employee} setFileName={setFileName} />
                            <Stack spacing={2} direction='row' alignItems={'center'}>
                                {departments?.length > 0 && (
                                    <Autocomplete id="department"
                                        disabled={disabled}
                                        getOptionLabel={(option) => option?.label ?? ''}
                                        options={[{label: 'New Department', id: 'new'}, ...(departments.map(d => {return {label: d.department, id: d.id}}))]}
                                        sx={{ width: '50vw' }}
                                        value={{ label: employeeFields.department, id: employeeFields.departmentId }}
                                        onChange={(event, newDepartment) => {
                                            const departmentValue = newDepartment?.label ?? '';
                                            if (newDepartment?.id === 'new') {
                                                handleClickOpenDialogNewDepartment();
                                            } else {
                                                setEmployeeFieldsToUpdate(prev => ({...prev, department: {department: departmentValue}, department_id: newDepartment?.id}));
                                                setEmployeeFields(prev => ({...prev, department: departmentValue, departmentId: newDepartment?.id}));
                                            }
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                label="Department"
                                                variant="standard"
                                                // error={emptyField.department.error}
                                                // helperText={emptyField.department.errorText}
                                            />}
                                    />
                                )}
                                {titles?.length > 0 && (
                                    <Autocomplete
                                        id="title"
                                        disabled={disabled}
                                        getOptionLabel={(option) => option?.label ?? ''}
                                        options={[{label: 'New Title', id: 'new'}, ...titles.map(t => {return {label: t.title, id: t.id}})]}
                                        sx={{ width: '50vw' }}
                                        value={{ label: employeeFields.title, id: employeeFields.titleId } || null}
                                        onChange={(event, newTitle) => {
                                            const titleLabel = newTitle?.label ?? '';
                                            if (newTitle?.id === 'new') {
                                                setOpenDialogNewTitle(true)
                                            } else {
                                                setEmployeeFieldsToUpdate(prev => ({...prev, title: {title: titleLabel}, title_id: newTitle?.id}));
                                                setEmployeeFields(prev => ({...prev, title: titleLabel, titleId: newTitle?.id}));
                                            }
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                label="Title"
                                                variant="standard"
                                                // error={emptyField.title.error}
                                                // helperText={emptyField.title.errorText}
                                            />}
                                    />
                                )}
                            </Stack>
                            
                            <Stack spacing={2} direction='row' alignItems={'center'}>
                                {employees?.length > 0 && (
                                    <Autocomplete id="manager"
                                        disabled={disabled}
                                        getOptionLabel={(option) => option?.label ?? ''}
                                        options={employees?.filter(e => e.etro_team && e.full_name && e.full_name.replace(/\s/g,'') !== '').map(e => {return {label: e.email}})}
                                        variant="standard"
                                        sx={{ width: '50vw' }}
                                        value={{label: employeeFields.manager, } || null}
                                        onChange={(event, newManager) => {
                                            const managerLabel = newManager?.label ?? '';
                                            if (coachChecked) {
                                                setEmployeeFieldsToUpdate(prev => ({ ...prev, direct_manager: managerLabel, coach: findManagerEmail(managerLabel) }))
                                                setEmployeeFields(prev => ({...prev, manager: managerLabel, coach: findManagerEmail(managerLabel)}));
                                            } else {
                                                setEmployeeFieldsToUpdate(prev => ({...prev, direct_manager: managerLabel}));
                                                setEmployeeFields(prev => ({...prev, manager: managerLabel}));
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label='Direct Manager'
                                                variant="standard"
                                                // error={emptyField.manager.error}
                                                // helperText={emptyField.manager.errorText}
                                            />
                                        )}
                                    />
                                )}
                                <>
                                    {'101892955716787254375' !== employeeId && (
                                        <FormGroup>
                                            <FormControlLabel
                                                sx={{
                                                    width: '15vw', '& .MuiFormControlLabel-label': { fontSize: '12px' },
                                                }}
                                                label='Coach is the same as direct manager'
                                                control={
                                                    <Checkbox
                                                        disabled={disabled}
                                                        checked={coachChecked}
                                                        onChange={(event) => {
                                                            setCoachChecked(event.target.checked)
                                                            setDisabledCoach(event.target.checked)
                                                            if (event.target.checked) {
                                                                setEmployeeFields(prev => ({...prev, coach: findManagerEmail(employeeFields.manager)}))
                                                                setEmployeeFieldsToUpdate(prev => ({ ...prev, coach: findManagerEmail(employeeFields.manager) }))
                                                            }
                                                        }}
                                                    />}
                                            >
                                            </FormControlLabel>
                                        </FormGroup>

                                    )}
                                    {employees?.length > 0 && (
                                        <Autocomplete id="coach"
                                            disabled={disabled || disabledCoach}
                                            getOptionLabel={(option) => option?.label ?? ''}
                                            options={employees?.filter(e => e.etro_team && e.full_name && e.full_name.replace(/\s/g,'') !== '').map(e => {return {label: e.full_name}})}
                                            sx={{ width: '50vw', visibility: '101892955716787254375' !== employeeId ? 'visible' : 'hidden' }}
                                            value={{label: employeeFields.coach} || null}
                                            onChange={(event, newCoach) => {
                                                const coachLabel = newCoach?.label ?? '';
                                                setEmployeeFields(prev => ({...prev, coach: coachLabel}));
                                                setEmployeeFieldsToUpdate(prev => ({...prev, coach: coachLabel}));
                                            }}
                                            renderInput={(params) => (
                                                <>
                                                    <TextField
                                                        {...params}
                                                        onKeyDown={(e) => {
                                                            !coachChecked ? '' : e.preventDefault()
                                                        }}
                                                        label={
                                                            <FormGroup>
                                                                <Stack direction='row' spacing={4}>
                                                                    <FormLabel>Coach</FormLabel>
                                                                </Stack>
                                                            </FormGroup>
                                                        }
                                                        variant="standard"
                                                        // error={emptyField.coach.error}
                                                        // helperText={emptyField.coach.errorText}
                                                    />
                                                </>
                                            )}
                                        
                                        />
                                    )}
                                </>
                            </Stack>
                            <Stack spacing={2} direction='row' alignItems={'center'}>
                                {workLocations?.length > 0 && ( 
                                    <Autocomplete
                                    id="work-location"
                                    disabled={disabled}
                                    getOptionLabel={(option) => option?.label ?? ''}
                                    options={[{ label: 'New Work Location', id: 'new' }, ...(workLocations.map(l => {return {label: l.building_name, id: l.id}}))]}
                                    sx={{ width: '60%' }}
                                    value={{ label: employeeFields.workLocation, id: employeeFields.workLocationId } || null}
                                    onChange={(event, newLocation) => {
                                        const locationLabel = newLocation?.label ?? '';
                                        const locationId = newLocation?.id ?? '';
                                        if (newLocation?.id === 'new') {
                                            navigate('/work-locations');
                                        } else {
                                            setEmployeeFields(prev => ({...prev, workLocation: locationLabel, workLocation_id: locationId}));
                                            setEmployeeFieldsToUpdate(prev => ({...prev, work_location: { building_name: locationLabel }, work_location_id: locationId})); 
                                        }
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            label="Work Location"
                                            variant="standard"
                                            // error={emptyField.workLocation.error}
                                            // helperText={emptyField.workLocation.errorText}
                                        />}
                                />
                                )}
                                <Autocomplete
                                    id="Phone-type"
                                    disabled={disabled}
                                    options={['ETRO Phone', 'Personal Phone']}
                                    sx={{ width: '20%' }}
                                    value={m[employeeFields.phoneType] || null}
                                    onChange={(event, newPhoneType) => {
                                        const phoneTypeLabel = newPhoneType ?? '';
                                        setEmployeeFields(prev => ({...prev, phoneType: m[phoneTypeLabel]}))
                                        setEmployeeFieldsToUpdate(prev => ({ ...prev, etro_type_phone: newPhoneType ? m[phoneTypeLabel] : '' }))
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Phone Type" variant="standard" />}
                                />
                                <TextField id="phone outlined-basic"
                                    disabled={disabled}
                                    label='Phone'
                                    variant="standard"
                                    sx={{ width: '20%' }}
                                    value={employeeFields.phone || ''}
                                    onChange={(event) => {
                                        const phone = event.target.value ?? '';
                                        setEmployeeFields(prev => ({...prev, phone: phone}));
                                        setEmployeeFieldsToUpdate(prev => ({ ...prev, phone: phone }))
                                    }}
                                />
                            </Stack>
                            <Stack direction="row" style={{ marginTop: 36 }} spacing={10} useFlexGap justifyContent="flex-end">
                                <Tooltip title="This action will suspend the User's ETRO accounts" placement="top">
                                    <span>
                                    <Button
                                        disabled={disabled}
                                        onClick={handleClickOpen}
                                        sx={{ backgroundColor: '#f44336', visibility: userEmployee?.is_lifecycle_admin ? 'visible' : 'hidden' }}
                                        variant="contained"
                                    >
                                        {employee?.suspended ? 'Activate' : 'Suspend'}
                                    </Button>
                                    </span>
                                </Tooltip>

                                <Stack direction='row' spacing={2}>
                                    <Button
                                        onClick={() => { handleReturnToListUser() }}
                                        color='error'
                                        variant="contained"
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        onClick={handleUpdateEmployee}
                                        // onClick={updateTitleVcard}
                                        disabled={disabled}
                                        color='success'
                                        variant="contained"
                                    >
                                        Save
                                    </Button>
                                </Stack>
                            </Stack>

                        </Stack>
                    </CardContent>
                </Card>
                <EmployeeDialogSuspend open={open} handleClose={handleCloseDialog} suspendUser={suspendUser} employee={employee} />
                <NewDepartmentDialog
                    openAlert={openAlert}
                    setEmployeeFields={setEmployeeFields}
                    setEmployeeFieldsToUpdate={setEmployeeFieldsToUpdate}
                    openDialogNewDepartment={openDialogNewDepartment}
                    handleCloseDialog={handleCloseDialog}
                />
                <Dialog
                    open={openChangePhoto}
                    id='add-photo'
                    onKeyDown={(e) => {
                        if (e.key === 'Escape') {
                            handleCloseDialog();
                        }
                    }}
                >
                    <DialogContent>
                        <Stack spacing={2}>
                            {fileName.length <= 0 ? (
                                <Stack>
                                    <Button variant="contained" component="span" onClick={handleClick}>
                                        Upload File
                                    </Button>
                                </Stack>
                            ) : (
                                <TextField
                                    InputProps={{ readOnly: true }}
                                    value={fileName}
                                    variant="standard"
                                    disabled />
                            )
                            }
                            <input
                                type="file"
                                ref={fileInputRef}
                                onChange={(e) => {
                                    setImage(e.target.files[0])
                                    setFileName(e.target.files[0].name)
                                }}
                                style={{ display: 'none' }}
                            />

                            <Stack spacing={0.5}>
                                <span><b>Format:</b> JPG or PNG.</span>
                                <span><b>Size:</b> Between 10 KB and 5 MB.</span>
                                <span><b>Recommended resolution:</b> 720 px tall, 720 px wide.</span>
                                <span><b>Minimum resolution:</b> 250 px tall, 250 px wide.</span>
                                <span><b>Quality:</b> The photo should be in focus and well lit, and have no significant
                                    alterations or excessive use of filters.
                                    In other words, the image should represent reality.</span>
                            </Stack>
                        </Stack>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={handleCloseDialog}

                            variant="contained"
                            color='error'
                        >Cancel</Button>
                        <Button
                            type='submit'
                            onClick={() => {
                                updateProfilePhoto()
                            }}
                            variant="contained"
                            color='success'
                        >Confirm</Button>

                    </DialogActions>
                </Dialog>
                <NewTitleDialog
                    openAlert={openAlert}
                    openDialogNewTitle={openDialogNewTitle}
                    handleCloseDialog={handleCloseDialog}
                    setEmployeeFields={setEmployeeFields}
                    setEmployeeFieldsToUpdate={setEmployeeFieldsToUpdate}
                />

            </>

        </Container >
    );
}

export default Profile;